import React from 'react';
import { useHistory } from 'react-router-dom';
import './index.less';
import PageLayout from '../../Components/pageLayout';

const ProjectDisclosure: React.FC = () => {
    const history = useHistory();

    return (
        <PageLayout history={history} children={[]} Content={
            <div className='page-container'>
                <h1 className='page-title'>捐赠公示</h1>
                {/* 页面内容将在这里添加 */}
            </div>
        } />
    );
};

export default ProjectDisclosure;